module.exports = __webpack_public_path__ + "img/vertical_7_1_8003.4db4c621.png";